import * as React from "react";
import { IpSetCreateForm } from "./form";

export const IpSetCreateInitializer: React.FC = () => {
  return <IpSetCreateForm />;
};
